<template>
  <img
    class="faded"
      :src="src"
      :class="{loaded}"
      @load="imgLoaded"
  />
</template>

<script>
export default {
  name: "MarkerDetailAnalyseImage",
  props: ['src'],
  data() {
    return {
      loaded: false,
    };
  },
  watch: {
    src(){
      this.loaded = false;
    }
  },
  methods: {
    imgLoaded(){
      this.loaded = true;
    }
  }
}
</script>

<style scoped>
  .faded {
    opacity: 1;
  }

  .faded.loaded {
    transition: opacity 0.3s ease-out;
    opacity: 1.0;
  }
</style>